<div class="travel-affiliations">
  <div class="travel-affiliations__hotel">
    <div class="travel-affiliations__hotel-left">
      <h4 class="travel-affiliations__hotel-header-text"><mat-icon fontSet="fa" fontIcon="fa-bed"></mat-icon> Hotels</h4>
      <div class="travel-affiliations__hotel-text">
        <div style="font-weight: bold">Exclusive members only discounted rates</div>
        <div>Wyndham Hotels & Resorts is pleased to partner with AOPA to offer their members exclusive members only discounted rates.</div>
      </div>
    </div>
    <div class="travel-affiliations__hotel-right">
      <div class="travel-affiliations__header-brand">
        <img src="assets/images/Wyndham-Logo165x40.png" width="165" height="40" class="travel-affiliations__logo" alt="Wyndham">
      </div>
      <div class="travel-affiliations__content-hotel-action">
        <div class="travel-affiliations__button">
          <a *ngIf="isAuthenticated(); else noAuthPlaceholder" mat-button href="https://www.wyndhamhotels.com/?corporate_id=1000081674"
             class="aopa-mat-btn aopa-mat-btn--filled" target="_blank">
            BOOK NOW
          </a>
        </div>
      </div>
      <div style="font-style: italic; font-size: small;">AOPA Member Discount Automatically Applied</div>
    </div>
  </div>
  <div class="travel-affiliations__header">
    <h4 class="travel-affiliations__header-text"><mat-icon fontSet="fa" fontIcon="fa-car"></mat-icon> Rental Cars</h4>
  </div>
  <div class="travel-affiliations__content">
    <div class="travel-affiliations__content-rental-car-section">

      <div class="travel-affiliations__content-rental-car">
        <div class="travel-affiliations__content-rental-car-header">
          <img src="assets/images/Avis-Logo.png" class="travel-affiliations__logo" alt="Avis">
        </div>
        <div class="travel-affiliations__button">
          <a mat-button href="https://www.avis.com/aopa" class="aopa-mat-btn aopa-mat-btn--filled" target="_blank">
            BOOK NOW
          </a>
        </div>
        <div class="travel-affiliations__phone">
          <a href="tel:1-800-577-1569"><mat-icon fontSet="fa" fontIcon="fa-phone"></mat-icon> 1-800-577-1569</a>
        </div>
      </div>

      <div class="travel-affiliations__content-rental-car">
        <div class="travel-affiliations__content-rental-car-header">
          <img src="assets/images/Enterprise-Logo.png" class="travel-affiliations__logo" alt="Enterprise">
        </div>
        <div class="travel-affiliations__button">
          <a mat-button href="https://partners.rentalcar.com/aopa2" class="aopa-mat-btn aopa-mat-btn--filled" target="_blank">
            BOOK NOW
          </a>
        </div>
        <div class="travel-affiliations__phone">
          <a href="tel:1-866-315-9155"><mat-icon fontSet="fa" fontIcon="fa-phone"></mat-icon> 1-866-315-9155</a>
        </div>
      </div>

      <div class="travel-affiliations__content-rental-car">
        <div class="travel-affiliations__content-rental-car-header">
          <img src="assets/images/Hertz-Logo.png" class="travel-affiliations__logo" alt="Hertz">
        </div>
        <div class="travel-affiliations__button">
          <a mat-button href="https://link.hertz.com/link.html?id=21434&LinkType=HZLK&target=special-offers/aopa&utm_source=aopa&utm_medium=referral&utm_campaign=h_aopa_sitebutton_destinationspg&utm_content=booknow" class="aopa-mat-btn aopa-mat-btn--filled" target="_blank">
            BOOK NOW
          </a>
        </div>
        <div class="travel-affiliations__phone">
          <a href="tel:1-877-631-5118"><mat-icon fontSet="fa" fontIcon="fa-phone"></mat-icon> 1-877-631-5118</a>
        </div>
      </div>

      <div class="travel-affiliations__content-rental-car">
        <div class="travel-affiliations__content-rental-car-header">
          <img src="assets/images/Budget-Logo.png" class="travel-affiliations__logo" alt="Budget">
        </div>
        <div class="travel-affiliations__button">
          <a mat-button href="https://www.budget.com/aopa" class="aopa-mat-btn aopa-mat-btn--filled" target="_blank">
            BOOK NOW
          </a>
        </div>
        <div class="travel-affiliations__phone">
          <a href="tel:1-800-527-0700"><mat-icon fontSet="fa" fontIcon="fa-phone"></mat-icon> 1-800-527-0700</a>
        </div>
      </div>

      <div class="travel-affiliations__content-rental-car">
        <div class="travel-affiliations__content-rental-car-header">
          <img src="assets/images/National-Logo.png" class="travel-affiliations__logo" alt="National">
        </div>
        <div class="travel-affiliations__button">
          <a mat-button href="https://partners.rentalcar.com/aopa2" class="aopa-mat-btn aopa-mat-btn--filled" target="_blank">
            BOOK NOW
          </a>
        </div>
        <div class="travel-affiliations__phone">
          <a href="tel:1-866-315-9155"><mat-icon fontSet="fa" fontIcon="fa-phone"></mat-icon> 1-866-315-9155</a>
        </div>
      </div>

      <div class="travel-affiliations__content-rental-car">
        <div class="travel-affiliations__content-rental-car-header">
          <img src="assets/images/Dollar_Logo-W.png" class="travel-affiliations__logo" alt="Dollar">
        </div>
        <div class="travel-affiliations__button">
          <a mat-button href="https://www.dollar.com/TravelCenter/Associations/aopa.aspx?corpdiscnbr=3060724&utm_source=aopa&utm_medium=referral&utm_campaign=d_aopa_sitebutton_destinationspg&utm_content=booknow" class="aopa-mat-btn aopa-mat-btn--filled" target="_blank">
            BOOK NOW
          </a>
        </div>
        <div class="travel-affiliations__phone">
          <a href="tel:1-800-800-4000"><mat-icon fontSet="fa" fontIcon="fa-phone"></mat-icon> 1-800-800-4000</a>
        </div>
      </div>

      <div class="travel-affiliations__content-rental-car__placeholder">
      </div>

      <div class="travel-affiliations__content-rental-car">
        <div class="travel-affiliations__content-rental-car-header">
          <img src="assets/images/Alamo-Logo.png" class="travel-affiliations__logo" alt="Alamo">
        </div>
        <div class="travel-affiliations__button">
          <a mat-button href="https://partners.rentalcar.com/aopa2" class="aopa-mat-btn aopa-mat-btn--filled" target="_blank">
            BOOK NOW
          </a>
        </div>
        <div class="travel-affiliations__phone">
          <a href="tel:1-866-315-9155"><mat-icon fontSet="fa" fontIcon="fa-phone"></mat-icon> 1-866-315-9155</a>
        </div>
      </div>

      <div class="travel-affiliations__content-rental-car">
        <div class="travel-affiliations__content-rental-car-header">
          <img src="assets/images/Thrifty_Logo-CMYK.png" class="travel-affiliations__logo" alt="Thrifty">
        </div>
        <div class="travel-affiliations__button">
          <a mat-button href="https://www.thrifty.com/travelcenter/associations/aopa.aspx?corpnum=3060725&utm_source=aopa&utm_medium=referral&utm_campaign=t_aopa_sitebutton_destinationspg&utm_content=booknow" class="aopa-mat-btn aopa-mat-btn--filled" target="_blank">
            BOOK NOW
          </a>
        </div>
        <div class="travel-affiliations__phone">
          <a href="tel:1-800-334-1705"><mat-icon fontSet="fa" fontIcon="fa-phone"></mat-icon> 1-800-334-1705</a>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #noAuthPlaceholder>
  <a mat-button (click)="redirectToLogin()" class="aopa-mat-btn aopa-mat-btn--filled" target="_blank">
    BOOK NOW
  </a>
</ng-template>
